import React, { useState, useEffect } from "react";
import OcrLayout from "./components/OcrLayout.jsx";
import NavPage from "./components/Nav.jsx";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";
import navItemsTest from './const/menu.json' ;
import { getProductList} from './utils/api';
import { getQueryString,checkIsInWhite } from './utils/index';


function Home(props) {
  const [action, setAction] = useState(""); //  当前选中菜单
  const [navItems, setNavItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentMune, setCurrentMune] = useState(null);

  useEffect(() => {
    async function func() {
      setLoading(true)
      const action = getQueryString('action');
      setAction(action);
      const res = await getProductList()
      setLoading(false);
      if (res?.config?.defaultConfig) {
        let _navItems = res.config.defaultConfig;
        // let _navItems = navItemsTest.defaultConfig;
        let _whiteList = [];
        _navItems.flat().map(i => {
          i.children.map(c => {
            if (c.whiteList?.length > 0) {
              _whiteList = _whiteList.concat(c.whiteList)
            }
          })
        });
        const whiteListRule = _whiteList.length <= 0 ? {} : await checkIsInWhite(_whiteList);

        _navItems = _navItems.flat().map(i => {
          return {
            ...i,
            children: i.children.filter(c => {
              // 配置了直接不显示
              if (typeof (c.IsHide) === 'boolean') {
                return !c.IsHide
                // 配置通过白名单显示
              } else if (typeof (c.IsHide) === 'object') {
                return whiteListRule[c.IsHide]?.length > 0
              } else {
                return true
              }
            }).map(child =>{
              return{
                ...child,
                menuKey:i.key
              }
            })
          }
        });
        setNavItems(_navItems);
        delCurrentMune(action,_navItems);
      }
    }
    func();

  }, [])

  const  delCurrentMune = (action,navItems = navItems) => {
        setAction(action);
        const list = navItems?.map(i => i.children).flat();
        const result = list?.find(i => {
          return i.action === action;
        });
        if(result){
          setAction(result.action);
          setCurrentMune(result);
        }
  }

  return (<>
    <Router>
      <Switch>
        <Route path="/">
        {
          loading ? <></> : <>
          {action ? <OcrLayout 
          menuList={navItems}
          action={action}
          currentMune={currentMune}
          defaultNavItems={navItems}
          onChangeAction={(action) => {
            setAction(action)
            delCurrentMune(action,navItems)
          }}
          /> : <NavPage 
          navList={navItems} 
          onChangeAction={(action) => {
            setAction(action)
            delCurrentMune(action,navItems)
            // TODO currentMune处理
          }}/>}
          </>
        }
          
        </Route>
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    </Router>
  </>

  );
}

export default Home;